import * as config from './config';
import { ClosetUnit } from './domain';

interface Envelope {
    error: {
        code: number,
        message: string,
    };
    result: unknown
}

export class APIError extends Error{
    code: number;
    constructor(code: number, message: string) {
        super(`APIError #${code}: ${message}`);
        this.code = code;
    }
}

/**
 * This is a convenience method for checking the JSON values of stuff we get
 * back from the server. Checks the data object for an error property. If it
 * exists, then an error is thrown with the error message contained in the
 * response. Otherwise, this function returns the `result` property.
 */
export const unwrap = (data: Envelope) => {
    if(data.error) {
        throw new APIError(
            data.error.code as number, data.error.message as string);
    } else if(data.result) {
        return data.result;
    } else {
        // TODO: we may not really want this as a fallback in production code
        return data;
    }
}

/**
 * Loads the given ID from the server. The embedding page will give us this ID
 * with a URL query string, i.e. index.html?id=123. Raises an APIException if
 * the server returns an error.
 */
export const load = async (id: string) => {
    const
        response = await fetch(`${config.endpoint}/${id}`),
        data = await response.json();
    return ClosetUnit.fromJSON(unwrap(data));
};

/**
 * Saves the given unit back to the server or raises an APIException with the
 * server error. The return value is whatever the server returns in te result
 * property, which could be undefined.
 */
export const save = async (unit: ClosetUnit) => {
    const
        response = await fetch(`${config.endpoint}/${unit.id}`),
        data = await response.json();
    return unwrap(data);
};


export const loadConfig = async () => {
    const
        response = await fetch(`${config.endpoint}/config.json`),
        data = await response.json();
    return unwrap(data);
};


export const apiUrl = (url: string | URL): URL => {
    const
        params = new URLSearchParams(location.search),
        profile = params.get('api-profile'),
        result = new URL(url, location.href);
    if(profile) {
        result.searchParams.set('api-profile', profile);
    }
    return result;
}

